import type { Component } from 'solid-js'
import { AdFreeIcon } from '~/components/icons/ad-free'
import { AllowListIcon } from '~/components/icons/allow-list'
import { DailyChallengeRewardIcon } from '~/components/icons/daily-challenge-reward'
import { EventRewardIcon } from '~/components/icons/event-reward'
import { RealTreeIcon } from '~/components/icons/real-tree'
import { SeasonalTreeIcon } from '~/components/icons/seasonal-tree'
import { TimeGuardIcon } from '~/components/icons/time-guard'
import { TripleCoinIcon } from '~/components/icons/triple-coin'
import { m } from '~/paraglide/messages'

export interface LostBenefit {
  label: string
  Icon: Component
}

/**
 * The lost-benefit list (GLOSSARY.md "Lost-benefit list"). A Pro user keeps
 * Pro benefits for life, so their list names Plus-only benefits.
 */
export function lostBenefits(isPremium: boolean): LostBenefit[] {
  const tripleCoin: LostBenefit = {
    label: m.subscription_exclusive_feature_sunshine_title(),
    Icon: TripleCoinIcon,
  }
  const seasonalTree: LostBenefit = {
    label: m.win_back_paywall_benefit_exclusive_content(),
    Icon: SeasonalTreeIcon,
  }
  return isPremium
    ? [
        seasonalTree,
        {
          label: m.win_back_paywall_benefit_event_reward(),
          Icon: EventRewardIcon,
        },
        {
          label: m.win_back_paywall_benefit_focus_challenge(),
          Icon: DailyChallengeRewardIcon,
        },
        tripleCoin,
        { label: m.win_back_paywall_benefit_app_block(), Icon: TimeGuardIcon },
      ]
    : [
        {
          label: m.win_back_paywall_benefit_custom_app_allow_list(),
          Icon: AllowListIcon,
        },
        { label: m.win_back_paywall_benefit_no_ads(), Icon: AdFreeIcon },
        tripleCoin,
        { label: m.win_back_paywall_benefit_real_tree(), Icon: RealTreeIcon },
        seasonalTree,
      ]
}
